export enum BasketballFreeThrowsAwardedAttribute {
  One = 502,
  Two = 503,
  Three = 504,
}
